import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/ReactToastify.css";
import { toastStatus } from "../constant/strings";

const ToastMessage = () => {
  return <ToastContainer position="top-right" autoClose={3000} />;
};

export const showToast = (message, type = toastStatus.info, onClose = null) => {
  const config = { onClose, autoClose: 1500 };
  switch (type) {
    case toastStatus.success:
      toast.success(message, config);
      break;
    case toastStatus.error:
      toast.error(message, config);
      break;
    case toastStatus.warn:
      toast.warn(message);
      break;
    default:
      toast(message, config);
  }
};

export default ToastMessage;
